import React from 'react';
const TIERS = [
  { name: 'Bronze', minSpend: 0, discount: '2%', members: 1240, color: '#CD7F32' },
  { name: 'Silver', minSpend: 500, discount: '5%', members: 680, color: '#94A3B8' },
  { name: 'Gold', minSpend: 1500, discount: '8%', members: 220, color: '#F59E0B' },
  { name: 'Platinum', minSpend: 5000, discount: '12%', members: 45, color: '#8B5CF6' },
];
const TOP_MEMBERS = [
  { name: 'Sarah Johnson', tier: 'Platinum', points: 12400, spent: 8200, visits: 142, joined: '2024-03-15' },
  { name: 'Mike Chen', tier: 'Platinum', points: 10800, spent: 7100, visits: 128, joined: '2024-01-20' },
  { name: 'Lisa Park', tier: 'Gold', points: 6200, spent: 4100, visits: 96, joined: '2024-06-10' },
  { name: 'David Wu', tier: 'Gold', points: 5800, spent: 3800, visits: 88, joined: '2024-08-22' },
  { name: 'Emma Davis', tier: 'Gold', points: 4600, spent: 3200, visits: 72, joined: '2025-01-05' },
];
const TC = { Platinum: '#8B5CF6', Gold: '#F59E0B', Silver: '#94A3B8', Bronze: '#CD7F32' };
export default function LoyaltyProgramPage() {
  const totalMembers = TIERS.reduce((a, t) => a + t.members, 0);
  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <div><h1 style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>Loyalty Program</h1><p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>Member tiers, points, and engagement tracking</p></div>
        <button style={{ padding: '10px 20px', background: 'var(--primary)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>+ Add Member</button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16, marginBottom: 24 }}>
        {TIERS.map(t => (
          <div key={t.name} style={{ padding: 20, background: 'var(--card)', borderRadius: 12, border: `1px solid ${t.color}40` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <span style={{ color: t.color, fontSize: 16, fontWeight: 700 }}>{t.name}</span>
              <span style={{ padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: `${t.color}20`, color: t.color }}>{t.discount} off</span>
            </div>
            <div style={{ color: 'var(--text)', fontSize: 28, fontWeight: 700 }}>{t.members.toLocaleString()}</div>
            <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>members {t.minSpend > 0 ? `(min $${t.minSpend}/yr)` : '(entry tier)'}</div>
          </div>
        ))}
      </div>
      <div style={{ background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', padding: 20, marginBottom: 16 }}>
        <div style={{ color: 'var(--text-muted)', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>Total Members</div>
        <div style={{ color: 'var(--primary)', fontSize: 32, fontWeight: 700 }}>{totalMembers.toLocaleString()}</div>
      </div>
      <div style={{ background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', overflow: 'auto' }}>
        <div style={{ padding: '16px 16px 0', color: 'var(--text)', fontSize: 14, fontWeight: 700 }}>Top Members</div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr>{['Member', 'Tier', 'Points', 'Total Spent', 'Visits', 'Joined'].map(h => (
            <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: 'var(--text-muted)', borderBottom: '1px solid var(--border)' }}>{h}</th>
          ))}</tr></thead>
          <tbody>{TOP_MEMBERS.map((m, i) => (
            <tr key={i} style={{ borderBottom: '1px solid var(--border)' }}>
              <td style={{ padding: '12px 16px', color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{m.name}</td>
              <td style={{ padding: '12px 16px' }}><span style={{ padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: `${TC[m.tier]}20`, color: TC[m.tier] }}>{m.tier}</span></td>
              <td style={{ padding: '12px 16px', color: 'var(--primary)', fontSize: 13, fontWeight: 700 }}>{m.points.toLocaleString()}</td>
              <td style={{ padding: '12px 16px', color: '#16A34A', fontSize: 13, fontWeight: 600 }}>${m.spent.toLocaleString()}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text)', fontSize: 13 }}>{m.visits}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text-muted)', fontSize: 12 }}>{m.joined}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
